/**
 * @generated SignedSource<<56704f869dd3bf26b9493dcc9318675d>>
 * @relayHash 47a9d4ba3c89adc65459e3e00e470969
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a276a4c71e6f6b8cd865f9fdff52d9b21ef5c500d0d49ccfd5a505cbe7b9c3dd

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiSupportWebsiteOverviewServiceHubPageQuery } from './uiSupportWebsiteOverviewServiceHubPageQuery.graphql';

const node: PreloadableConcreteRequest<uiSupportWebsiteOverviewServiceHubPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a276a4c71e6f6b8cd865f9fdff52d9b21ef5c500d0d49ccfd5a505cbe7b9c3dd",
    "metadata": {},
    "name": "uiSupportWebsiteOverviewServiceHubPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
